export default "__VITE_ASSET__Z03bKSwc__"